/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("fi", {
  Redo: "Tee uudelleen",
  Undo: "Kumoa",
  Cut: "Leikkaa",
  Copy: "Kopioi",
  Paste: "Liit\u00e4",
  "Select all": "Valitse kaikki",
  "New document": "Uusi asiakirja",
  Ok: "Ok",
  Cancel: "Peruuta",
  "Visual aids": "Visuaaliset neuvot",
  Bold: "Lihavoitu",
  Italic: "Kursivoitu",
  Underline: "Alleviivaus",
  Strikethrough: "Yliviivaus",
  Superscript: "Yl\u00e4indeksi",
  Subscript: "Alaindeksi",
  "Clear formatting": "Poista muotoilu",
  "Align left": "Tasaa vasemmalle",
  "Align center": "Tasaa keskelle",
  "Align right": "Tasaa oikealle",
  Justify: "Tasaus",
  "Bullet list": "J\u00e4rjest\u00e4m\u00e4t\u00f6n lista",
  "Numbered list": "J\u00e4rjestetty lista",
  "Decrease indent": "Sisenn\u00e4",
  "Increase indent": "Loitonna",
  Close: "Sulje",
  Formats: "Muotoilut",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Selaimesi ei tue leikep\u00f6yd\u00e4n suoraa k\u00e4ytt\u00e4mist\u00e4. Ole hyv\u00e4 ja k\u00e4yt\u00e4 n\u00e4pp\u00e4imist\u00f6n Ctrl+X/C/V n\u00e4pp\u00e4inyhdistelmi\u00e4.",
  Headers: "Otsikot",
  "Header 1": "Otsikko 1",
  "Header 2": "Otsikko 2",
  "Header 3": "Otsikko 3",
  "Header 4": "Otsikko 4",
  "Header 5": "Otsikko 5",
  "Header 6": "Otsikko 6",
  Headings: "Otsikot",
  "Heading 1": "Otsikko 1",
  "Heading 2": "Otsikko 2",
  "Heading 3": "Otsikko 3",
  "Heading 4": "Otsikko 4",
  "Heading 5": "Otsikko 5",
  "Heading 6": "Otsikko 6",
  Preformatted: "Esimuotoiltu",
  Div: "Div",
  Pre: "Pre",
  Code: "Koodi",
  Paragraph: "Kappale",
  Blockquote: "Lohkolainaus",
  Inline: "Samalla rivill\u00e4",
  Blocks: "Lohkot",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Liitt\u00e4minen on nyt pelk\u00e4n tekstin -tilassa. Sis\u00e4ll\u00f6t liitet\u00e4\u00e4n nyt pelkk\u00e4n\u00e4 tekstin\u00e4, kunnes otat vaihtoehdon pois k\u00e4yt\u00f6st\u00e4.",
  Fonts: "Fontti",
  "Font Sizes": "Fonttikoko",
  Class: "Luokka",
  "Browse for an image": "Selaa kuvia",
  OR: "TAI",
  "Drop an image here": "Pudota kuva t\u00e4h\u00e4n",
  Upload: "Vie",
  Block: "Lohko",
  Align: "Tasaa",
  Default: "Oletus",
  Circle: "Pallo",
  Disc: "Ympyr\u00e4",
  Square: "Neli\u00f6",
  "Lower Alpha": "pienet kirjaimet: a, b, c",
  "Lower Greek": "pienet kirjaimet: \u03b1, \u03b2, \u03b3",
  "Lower Roman": "pienet kirjaimet: i, ii, iii",
  "Upper Alpha": "isot kirjaimet: A, B, C",
  "Upper Roman": "isot kirjaimet: I, II, III",
  "Anchor...": "Ankkuri...",
  Name: "Nimi",
  Id: "Id",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "Id voi alkaa kirjaimella, sen j\u00e4lkeen voi k\u00e4ytt\u00e4\u00e4 kirjaimia, numeroja, viivoja, pisteit\u00e4, kaksoispistett\u00e4 ja alaviivausta",
  "You have unsaved changes are you sure you want to navigate away?":
    "Sinulla on tallentamattomia muutoksia, haluatko varmasti siirty\u00e4 toiselle sivulle?",
  "Restore last draft": "Palauta aiempi luonnos",
  "Special character...": "Erikoismerkki...",
  "Source code": "L\u00e4hdekoodi",
  "Insert/Edit code sample": "Lis\u00e4\u00e4/muokkaa koodiesimerkki",
  Language: "Kieli",
  "Code sample...": "Koodin\u00e4yte...",
  "Color Picker": "V\u00e4rivalitsin",
  R: "R",
  G: "G",
  B: "B",
  "Left to right": "Vasemmalta oikealle",
  "Right to left": "Oikealta vasemmalle",
  "Emoticons...": "Emoticonit...",
  "Metadata and Document Properties": "Metadata ja asiakirjan ominaisuudet",
  Title: "Otsikko",
  Keywords: "Avainsanat",
  Description: "Kuvaus",
  Robots: "Robotit",
  Author: "Tekij\u00e4",
  Encoding: "Merkist\u00f6",
  Fullscreen: "Koko ruutu",
  Action: "Toiminto",
  Shortcut: "Oikotie",
  Help: "Ohje",
  Address: "Osoite",
  "Focus to menubar": "Kohdistus valikkoon",
  "Focus to toolbar": "Kohdistus ty\u00f6kalupalkkiin",
  "Focus to element path": "Kohdistus elementtiin",
  "Focus to contextual toolbar":
    "Kohdistus kontekstuaaliseen ty\u00f6kalupalkkiin",
  "Insert link (if link plugin activated)":
    "Lis\u00e4\u00e4 linkki (jos linkki-liit\u00e4nn\u00e4inen aktiivinen)",
  "Save (if save plugin activated)":
    "Tallenna (jos tallenna-liit\u00e4nn\u00e4inen aktiivinen)",
  "Find (if searchreplace plugin activated)":
    "Etsi (jos etsikorvaa-liit\u00e4nn\u00e4inen aktiivinen)",
  "Plugins installed ({0}):": "Asennetut liit\u00e4nn\u00e4iset ({0}):",
  "Premium plugins:": "Premium liit\u00e4nn\u00e4iset:",
  "Learn more...": "Lis\u00e4tietoja...",
  "You are using {0}": "K\u00e4yt\u00e4t {0}",
  Plugins: "Liit\u00e4nn\u00e4iset",
  "Handy Shortcuts": "K\u00e4tev\u00e4t pikan\u00e4pp\u00e4imet",
  "Horizontal line": "Vaakasuora viiva",
  "Insert/edit image": "Lis\u00e4\u00e4/muokkaa kuva",
  "Image description": "Kuvaus",
  Source: "L\u00e4hde",
  Dimensions: "Mittasuhteet",
  "Constrain proportions": "S\u00e4ilyt\u00e4 mittasuhteet",
  General: "Yleiset",
  Advanced: "Lis\u00e4asetukset",
  Style: "Tyyli",
  "Vertical space": "Vertikaalinen tila",
  "Horizontal space": "Horisontaalinen tila",
  Border: "Reunus",
  "Insert image": "Lis\u00e4\u00e4 kuva",
  "Image...": "Kuva...",
  "Image list": "Kuvalista",
  "Rotate counterclockwise": "Kierr\u00e4 vastap\u00e4iv\u00e4\u00e4n",
  "Rotate clockwise": "Kierr\u00e4 my\u00f6t\u00e4p\u00e4iv\u00e4\u00e4n",
  "Flip vertically": "K\u00e4\u00e4nn\u00e4 pystysuunnassa",
  "Flip horizontally": "K\u00e4\u00e4nn\u00e4 vaakasuunnassa",
  "Edit image": "Muokkaa kuvaa",
  "Image options": "Kuvan asetukset",
  "Zoom in": "L\u00e4henn\u00e4",
  "Zoom out": "Loitonna",
  Crop: "Rajaa valintaan",
  Resize: "Kuvan koon muutos",
  Orientation: "Suunta",
  Brightness: "Kirkkaus",
  Sharpen: "Ter\u00e4vyys",
  Contrast: "Kontrasti",
  "Color levels": "V\u00e4ritasot",
  Gamma: "Gamma",
  Invert: "K\u00e4\u00e4nteinen",
  Apply: "Aseta",
  Back: "Takaisin",
  "Insert date/time":
    "Lis\u00e4\u00e4 p\u00e4iv\u00e4m\u00e4\u00e4r\u00e4 tai aika",
  "Date/time": "P\u00e4iv\u00e4m\u00e4\u00e4r\u00e4/aika",
  "Insert/Edit Link": "Lis\u00e4\u00e4 linkki/muokkaa linkki\u00e4",
  "Insert/edit link": "Lis\u00e4\u00e4/muokkaa linkki",
  "Text to display": "N\u00e4ytett\u00e4v\u00e4 teksti",
  Url: "Osoite",
  "Open link in...": "Avaa linkki...",
  "Current window": "Nykyinen ikkuna",
  None: "Ei mit\u00e4\u00e4n",
  "New window": "Uusi ikkuna",
  "Remove link": "Poista linkki",
  Anchors: "Ankkurit",
  "Link...": "Linkki...",
  "Paste or type a link": "Sijoita tai kirjoita linkki",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "Antamasi osoite n\u00e4ytt\u00e4\u00e4 olevan s\u00e4hk\u00f6postiosoite. Haluatko lis\u00e4t\u00e4 osoitteeseen vaaditun mailto: -etuliitteen?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "Antamasi osoite n\u00e4ytt\u00e4\u00e4 olevan ulkoinen linkki. Haluatko lis\u00e4t\u00e4 osoitteeseen vaaditun http:// -etuliitteen?",
  "Link list": "Linkkilista",
  "Insert video": "Lis\u00e4\u00e4 video",
  "Insert/edit video": "Lis\u00e4\u00e4/muokkaa video",
  "Insert/edit media": "Lis\u00e4\u00e4/muokkaa media",
  "Alternative source": "Vaihtoehtoinen l\u00e4hde",
  "Alternative source URL": "Vaihtoehtoinen l\u00e4hde-URL",
  "Media poster (Image URL)": "Median julkaisija (kuvan URL)",
  "Paste your embed code below:": "Liit\u00e4 upotuskoodisi alapuolelle:",
  Embed: "Upota",
  "Media...": "Media...",
  "Nonbreaking space": "Sitova v\u00e4lily\u00f6nti",
  "Page break": "Sivunvaihto",
  "Paste as text": "Liit\u00e4 tekstin\u00e4",
  Preview: "Esikatselu",
  "Print...": "Tulosta",
  Save: "Tallenna",
  Find: "Etsi",
  "Replace with": "Korvaa",
  Replace: "Korvaa",
  "Replace all": "Korvaa kaikki",
  Previous: "Edellinen",
  Next: "Seur.",
  "Find and replace...": "Etsi ja korvaa...",
  "Could not find the specified string.":
    "Haettua merkkijonoa ei l\u00f6ytynyt.",
  "Match case": "Erota isot ja pienet kirjaimet",
  "Find whole words only": "Etsi vain kokonaisia sanoja",
  "Spell check": "Oikeinkirjoituksen tarkistus",
  Ignore: "\u00c4l\u00e4 huomioi",
  "Ignore all": "\u00c4l\u00e4 huomioi mit\u00e4\u00e4n",
  Finish: "Lopeta",
  "Add to Dictionary": "Lis\u00e4\u00e4 sanakirjaan",
  "Insert table": "Lis\u00e4\u00e4 taulukko",
  "Table properties": "Taulukon ominaisuudet",
  "Delete table": "Poista taulukko",
  Cell: "Solu",
  Row: "Rivi",
  Column: "Sarake",
  "Cell properties": "Solun ominaisuudet",
  "Merge cells": "Yhdist\u00e4 solut",
  "Split cell": "Jaa solu",
  "Insert row before": "Lis\u00e4\u00e4 rivi ennen",
  "Insert row after": "Lis\u00e4\u00e4 rivi j\u00e4lkeen",
  "Delete row": "Poista rivi",
  "Row properties": "Rivin ominaisuudet",
  "Cut row": "Leikkaa rivi",
  "Copy row": "Kopioi rivi",
  "Paste row before": "Liit\u00e4 rivi ennen",
  "Paste row after": "Liit\u00e4 rivi j\u00e4lkeen",
  "Insert column before": "Lis\u00e4\u00e4 rivi ennen",
  "Insert column after": "Lis\u00e4\u00e4 rivi j\u00e4lkeen",
  "Delete column": "Poista sarake",
  Cols: "Sarakkeet",
  Rows: "Rivit",
  Width: "Leveys",
  Height: "Korkeus",
  "Cell spacing": "Solun v\u00e4li",
  "Cell padding": "Solun tyhj\u00e4 tila",
  "Show caption": "N\u00e4yt\u00e4 kuvateksti",
  Left: "Vasen",
  Center: "Keskell\u00e4",
  Right: "Oikea",
  "Cell type": "Solun tyyppi",
  Scope: "Laajuus",
  Alignment: "Tasaus",
  "H Align": "H tasaus",
  "V Align": "V tasaus",
  Top: "Yl\u00e4reuna",
  Middle: "Keskikohta",
  Bottom: "Alareuna",
  "Header cell": "Otsikkosolu",
  "Row group": "Riviryhm\u00e4",
  "Column group": "Sarakeryhm\u00e4",
  "Row type": "Rivityyppi",
  Header: "Otsikko",
  Body: "Runko",
  Footer: "Alaosa",
  "Border color": "Reunuksen v\u00e4ri",
  "Insert template...": "Lis\u00e4\u00e4 malli...",
  Templates: "Pohjat",
  Template: "Pohja",
  "Text color": "Tekstin v\u00e4ri",
  "Background color": "Taustan v\u00e4ri",
  "Custom...": "Mukauta...",
  "Custom color": "Mukautettu v\u00e4ri",
  "No color": "Ei v\u00e4ri\u00e4",
  "Remove color": "Poista v\u00e4ri",
  "Table of Contents": "Sis\u00e4llysluettelo",
  "Show blocks": "N\u00e4yt\u00e4 lohkot",
  "Show invisible characters":
    "N\u00e4yt\u00e4 n\u00e4kym\u00e4tt\u00f6m\u00e4t merkit",
  "Word count": "Sanam\u00e4\u00e4r\u00e4",
  Count: "M\u00e4\u00e4r\u00e4",
  Document: "Tiedosto",
  Selection: "Valinta",
  Words: "Sanaa",
  "Words: {0}": "Sanat: {0}",
  "{0} words": "{0} sanaa",
  File: "Tiedosto",
  Edit: "Muokkaa",
  Insert: "Lis\u00e4\u00e4",
  View: "N\u00e4yt\u00e4",
  Format: "Muotoilu",
  Table: "Taulukko",
  Tools: "Ty\u00f6kalut",
  "Powered by {0}": "Tehty {0}:ll\u00e4",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Rikastetun tekstin alue. Paina ALT-F9 valikkoon. Paina ALT-F10 ty\u00f6kaluriviin. Paina ALT-0 ohjeeseen.",
  "Image title": "Kuvan otsikko",
  "Border width": "Reunuksen leveys",
  "Border style": "Reunuksen tyyli",
  Error: "Virhe",
  Warn: "Varoitus",
  Valid: "Voimassa",
  "To open the popup, press Shift+Enter":
    "Avaa ponnahdusikkuna painamalla Shift+Enter",
  "Rich Text Area. Press ALT-0 for help.":
    "Rikastetun tekstin alue. Avaa ohje painamalla ALT-0.",
  "System Font": "J\u00e4rjestelm\u00e4fontti",
  "Failed to upload image: {0}": "Kuvan lataus ep\u00e4onnistui: {0}",
  "Failed to load plugin: {0} from url {1}":
    "Liit\u00e4nn\u00e4isen lataus ep\u00e4onnistui: {0} url:st\u00e4 {1}",
  "Failed to load plugin url: {0}":
    "Liit\u00e4nn\u00e4isen url:n lataus ep\u00e4onnistui: {0}",
  "Failed to initialize plugin: {0}":
    "Liit\u00e4nn\u00e4isen alustus ep\u00e4onnistui: {0}",
  example: "esimerkki",
  Search: "Etsi",
  All: "Kaikki",
  Currency: "Valuutta",
  Text: "Teksti",
  Quotations: "Lainaukset",
  Mathematical: "Matemaattiset",
  "Extended Latin": "Laajennettu latina",
  Symbols: "Symbolit",
  Arrows: "Nuolet",
  "User Defined": "K\u00e4ytt\u00e4j\u00e4m\u00e4\u00e4ritetty",
  "dollar sign": "dollarimerkki",
  "currency sign": "valuuttamerkki",
  "euro-currency sign": "eurovaluuttamerkki",
  "colon sign": "kaksoispisteen merkki",
  "cruzeiro sign": "cruzeiro-merkki",
  "french franc sign": "ranskalaisen frangin merkki",
  "lira sign": "liiran merkki",
  "mill sign": "millin merkki",
  "naira sign": "nairan merkki",
  "peseta sign": "pesetan merkki",
  "rupee sign": "rupian merkki",
  "won sign": "wonin merkki",
  "new sheqel sign": "uuden sekelin merkki",
  "dong sign": "dongin merkki",
  "kip sign": "kipin merkki",
  "tugrik sign": "tugrikin merkki",
  "drachma sign": "drakman merkki",
  "german penny symbol": "saksalaisen pennin merkki",
  "peso sign": "peson merkki",
  "guarani sign": "guaranin merkki",
  "austral sign": "australin merkki",
  "hryvnia sign": "hryvnian merkki",
  "cedi sign": "cedin merkki",
  "livre tournois sign": "livre tournoisin merkki",
  "spesmilo sign": "spesmilon merkki",
  "tenge sign": "tengen merkki",
  "indian rupee sign": "intialaisen rupian merkki",
  "turkish lira sign": "turkkilaisen liiran merkki",
  "nordic mark sign": "pohjoismaisen markan merkki",
  "manat sign": "manatin merkki",
  "ruble sign": "ruplan merkki",
  "yen character": "jenin merkki",
  "yuan character": "juanin merkki",
  "yuan character, in hong kong and taiwan":
    "juanin merkki, Hongkongissa ja Taiwanissa",
  "yen/yuan character variant one": "jenin/juanin merkin variantti",
  "Loading emoticons...": "Ladataan emoticoneja...",
  "Could not load emoticons": "Emoticoneja ei voitu ladata",
  People: "Ihmiset",
  "Animals and Nature": "El\u00e4imet ja luonto",
  "Food and Drink": "Ruoka ja juoma",
  Activity: "Aktiviteetit",
  "Travel and Places": "Matkailu ja paikat",
  Objects: "Esineet",
  Flags: "Liput",
  Characters: "Merkki\u00e4",
  "Characters (no spaces)": "Merkki\u00e4 (ilman v\u00e4lily\u00f6ntej\u00e4)",
  "{0} characters": "{0} merkki\u00e4",
  "Error: Form submit field collision.":
    "Virhe: lomakkeen l\u00e4hetyskent\u00e4n t\u00f6rm\u00e4ys.",
  "Error: No form element found.":
    "Virhe: muotoelementti\u00e4 ei l\u00f6ytynyt.",
  Update: "P\u00e4ivit\u00e4",
  "Color swatch": "V\u00e4rin\u00e4yte",
  Turquoise: "Turkoosi",
  Green: "Vihre\u00e4",
  Blue: "Sininen",
  Purple: "Purppura",
  "Navy Blue": "Laivastonsininen",
  "Dark Turquoise": "Tumma turkoosi",
  "Dark Green": "Tumma vihre\u00e4",
  "Medium Blue": "Keskitumma sininen",
  "Medium Purple": "Keskitumma purppura",
  "Midnight Blue": "keskiy\u00f6n sininen",
  Yellow: "Keltainen",
  Orange: "Oranssi",
  Red: "Punainen",
  "Light Gray": "Vaaleanharmaa",
  Gray: "Harmaa",
  "Dark Yellow": "Tummankeltainen",
  "Dark Orange": "Tumma oranssi",
  "Dark Red": "Tumma punainen",
  "Medium Gray": "Keskiharmaa",
  "Dark Gray": "Tummanharmaa",
  "Light Green": "Vaaleanvihre\u00e4",
  "Light Yellow": "Vaaleankeltainen",
  "Light Red": "Vaaleanpunainen",
  "Light Purple": "Liila",
  "Light Blue": "Vaaleansininen",
  "Dark Purple": "Tummanvioletti",
  "Dark Blue": "Tummansininen",
  Black: "Musta",
  White: "Valkoinen",
  "Switch to or from fullscreen mode":
    "Vaihda kokon\u00e4ytt\u00f6\u00f6n tai kokon\u00e4yt\u00f6st\u00e4",
  "Open help dialog": "Avaa ohjeen valintaikkuna",
  history: "historia",
  styles: "tyylit",
  formatting: "muotoiltu",
  alignment: "tasaus",
  indentation: "sisennys",
  "permanent pen": "pysyv\u00e4 kyn\u00e4",
  comments: "kommentit",
  "Format Painter": "Muotoilusivellin",
  "Insert/edit iframe": "Lis\u00e4\u00e4/muokkaa iframe-kehyst\u00e4",
  Capitalization: "Kapitalisointi",
  lowercase: "pienaakkoset",
  UPPERCASE: "SUURAAKKOSET",
  "Title Case": "Otsikon kapitalisointi",
  "Permanent Pen Properties": "Pysyv\u00e4t kyn\u00e4n ominaisuudet",
  "Permanent pen properties...": "Pysyv\u00e4t kyn\u00e4n ominaisuudet...",
  Font: "Fontti",
  Size: "Koko",
  "More...": "Lis\u00e4\u00e4...",
  "Spellcheck Language": "Oikoluvun kieli",
  "Select...": "Valitse...",
  Preferences: "Asetukset",
  Yes: "Kyll\u00e4",
  No: "Ei",
  "Keyboard Navigation": "Navigointi n\u00e4pp\u00e4imist\u00f6ll\u00e4",
  Version: "Versio",
  Anchor: "Ankkuri",
  "Special character": "Erikoismerkki",
  "Code sample": "Koodiesimerkki",
  Color: "V\u00e4ri",
  Emoticons: "Hymi\u00f6t",
  "Document properties": "Dokumentin ominaisuudet",
  Image: "Kuva",
  "Insert link": "Lis\u00e4\u00e4 linkki",
  Target: "Kohde",
  Link: "Linkki",
  Poster: "L\u00e4hett\u00e4j\u00e4",
  Media: "Media",
  Print: "Tulosta",
  Prev: "Edel.",
  "Find and replace": "Etsi ja korvaa",
  "Whole words": "Koko sanat",
  Spellcheck: "Oikolue",
  Caption: "Seloste",
  "Insert template": "Lis\u00e4\u00e4 pohja",
});
